export var componentsManage = {
  // name: "组件管理",
  // path: "/components",
  // hidden: false,
  // redirect: "noredirect",
  // component: "Layout",
  // elemCode: "97",
  // alwaysShow: true,
  // meta: {
  //     title: "组件管理",
  //     icon: "theme",
  //     noCache: true
  // },
  // children: [{
  //     name: "Icons",
  //     path: 'iconStore',
  //     hidden: false,
  //     component: "components/icons/index",
  //     elemCode: "98",
  //     meta: {
  //         title: "图标库",
  //         noCache: true
  //     }
  // }]
};